export default "__VITE_PUBLIC_ASSET__ff5c4113__"